import { render } from "./GlPage.vue?vue&type=template&id=11346b0d&scoped=true"
import script from "./GlPage.vue?vue&type=script&lang=js"
export * from "./GlPage.vue?vue&type=script&lang=js"

import "./GlPage.vue?vue&type=style&index=0&id=11346b0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11346b0d"

export default script